import { beTarask } from "../../../../date-fns/locale/be-tarask.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    beTarask
  }
};